// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__xoiIp","buttons":"SendReceipts_buttons__2hGmN","email":"SendReceipts_email__1VJIP","bookApptTitle":"SendReceipts_bookApptTitle__3UOfx"};